import React, { useMemo, useState } from "react";
import jetsData from "../data/jets.json";
import JetCard from "./JetCard";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "./Inventory.css"; // <-- pense bien à réimporter ton CSS
import { useTranslation, Trans } from "react-i18next";
const CATEGORIES = [
  "VLJ","Light Jet","Midsize Jet","Super Midsize","Large Cabin","Ultra Long Range","Bizliner"
];

export default function Inventory() {
  const bounds = useMemo(() => {
    const years  = jetsData.map(j => j.year);
    const caps   = jetsData.map(j => j.capacity);
    const hours  = jetsData.map(j => j.hours || 0);
    const min = (arr) => Math.min(...arr);
    const max = (arr) => Math.max(...arr);
    return {
      yearMin:  min(years),  yearMax:  max(years),
      capMin:   min(caps),   capMax:   max(caps),
      hrsMin:   min(hours),  hrsMax:   max(hours)
    };
  }, []);
  const { t } = useTranslation("inventory");
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [capacityMin, setCapacityMin] = useState(bounds.capMin);
  const [years, setYears] = useState([bounds.yearMin, bounds.yearMax]);
  const [hours, setHours] = useState([bounds.hrsMin, bounds.hrsMax]);
  const [manufacturers, setManufacturers] = useState([]);

  const makers = useMemo(
    () => Array.from(new Set(jetsData.map(j => j.manufacturer))).sort(),
    []
  );

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    return jetsData.filter(j => {
      if (q && !(j.name + " " + j.manufacturer).toLowerCase().includes(q)) return false;
      if (category && j.category !== category) return false;
      if (j.capacity < capacityMin) return false;
      if (j.year < years[0] || j.year > years[1]) return false;
      const h = j.hours ?? 0;
      if (h < hours[0] || h > hours[1]) return false;
      if (manufacturers.length && !manufacturers.includes(j.manufacturer)) return false;
      return true;
    });
  }, [search, category, capacityMin, years, hours, manufacturers]);

  const toggleMaker = (m) =>
    setManufacturers(prev => prev.includes(m) ? prev.filter(x => x !== m) : [...prev, m]);

  const reset = () => {
    setSearch(""); setCategory("");
    setCapacityMin(bounds.capMin);
    setYears([bounds.yearMin, bounds.yearMax]);
    setHours([bounds.hrsMin, bounds.hrsMax]);
    setManufacturers([]);
  };

  return (
    <section className="inventory">
      <div className="inventory-head">
        <h2>{t("title")}</h2>
        <div className="search-wrapper">
          <input
            className="search-input"
            placeholder={t("searchPlaceholder")}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* FILTRES */}
      <div className="filters">
        <div className="field">
          <label>{t("filters.category")}</label>
          <select value={category} onChange={e => setCategory(e.target.value)}>
            <option value="">{t("filters.all")}</option>
            {CATEGORIES.map(c => (
              <option key={c} value={c}>{t(`categories.${c}`)}</option>
            ))}
          </select>
        </div>

        <div className="field">
          <label>{t("filters.capacity")} min. : <strong>{capacityMin} pax</strong></label>
          <Slider
            className="ui-slider"
            min={bounds.capMin}
            max={bounds.capMax}
            value={capacityMin}
            onChange={setCapacityMin}
          />
        </div>

        <div className="field">
          <label>{t("filters.year")} : <strong>{years[0]}</strong> – <strong>{years[1]}</strong></label>
          <Slider
            className="ui-slider"
            range
            min={bounds.yearMin}
            max={bounds.yearMax}
            allowCross={false}
            value={years}
            onChange={setYears}
          />
        </div>

        <div className="field">
          <label>
            {t("filters.hours")} : <strong>{hours[0].toLocaleString()}</strong> – <strong>{hours[1].toLocaleString()}</strong>
          </label>
          <Slider
            className="ui-slider"
            range
            min={bounds.hrsMin}
            max={bounds.hrsMax}
            step={50}
            allowCross={false}
            value={hours}
            onChange={setHours}
          />
        </div>

        <div className="field makers">
          <label>{t("filters.makers")}</label>
          <div className="chips">
            {makers.map(m => (
              <button
                key={m}
                type="button"
                className={`chip ${manufacturers.includes(m) ? "active" : ""}`}
                onClick={() => toggleMaker(m)}
              >
                {m}
              </button>
            ))}
          </div>
        </div>

        <button className="btn ghost" onClick={reset}>{t("filters.reset")}</button>
      </div>

      {/* LISTE */}
      <div className="jet-list-rows">
        {filtered.length === 0 && <p className="empty">{t("empty")}</p>}
        {filtered.map((jet, idx) => (
          <JetCard key={jet.id} jet={jet} reverse={idx % 2 === 1} />
        ))}
      </div>
    </section>
  );
}
